export const TABLE_DATA_EDITOR_WIDTH_PX = 400;
export const X_SPREADSHEET_ROOT_ID = "table-data-editor-x-spreadsheet";
